<template lang="html">
  <div :class="klass">
    <input
      :type="type"
      :name="name"
      :value="model"
      :class="[error ? 'error-input' : '']"
      @change="onchange"
      :placeholder="placeholder"
      :disabled="disabled"
    />
    <div class="error-message" v-if="error">{{error}}</div>
  </div>
</template>

<script>
export default {
  props: {
    klass: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text',
    },
    model: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: undefined,
    },
    onchange: {
      type: Function,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: String,
      default: undefined,
    }
  },
}
</script>

<style lang="css" scoped>
.error-message {
  color: #EE787D !important;
  letter-spacing: 0.045px;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  margin-top: 6px;
}

input:disabled {
  cursor: not-allowed;
  background: #DCDFFB;
}
</style>
